import { useState } from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { AUTH_FIELD_SX } from "../pages/AuthLayout";
import { sanitizePasswordInput } from "../utils/inputValidation";

export default function PasswordField({
  sx = AUTH_FIELD_SX,
  InputProps,
  onChange,
  ...props
}) {
  const [visible, setVisible] = useState(false);

  const handleChange = (event) => {
    if (!onChange) {
      return;
    }

    onChange({
      ...event,
      target: {
        ...event.target,
        id: event.target.id,
        value: sanitizePasswordInput(event.target.value),
      },
    });
  };

  return (
    <TextField
      {...props}
      type={visible ? "text" : "password"}
      sx={sx}
      onChange={handleChange}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              type="button"
              aria-label={visible ? "Скрыть пароль" : "Показать пароль"}
              onClick={() => setVisible((prev) => !prev)}
              onMouseDown={(event) => event.preventDefault()}
              edge="end"
              size="small"
              sx={{ color: "#64748b" }}
            >
              {visible ? (
                <VisibilityOffOutlinedIcon fontSize="small" />
              ) : (
                <VisibilityOutlinedIcon fontSize="small" />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
